import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { GetTeamResponse } from '../../../../shared/types/routes/teams';

//  Actual function to fetch a single team
function fetchTeam(id: number) {
  return get<GetTeamResponse>(`/api/v2/teams/${id}`);
}

/**
 * Unique identifier for the team query.
 */
export const getTeamQueryKey = (teamId: number): QueryKey => ['teams', teamId];

/**
 * useTeams is a hook that fetches and returns the teams the
 * current user has access to from /api/teams.
 */
export default function useTeam(teamId: number) {
  return useQuery<GetTeamResponse>({
    queryKey: getTeamQueryKey(teamId),
    queryFn: () => fetchTeam(teamId),
  });
}
